<script>
import ModalSimulatorOfficialSectionComponent from '../../features/modals/ModalSimulatorOfficialSectionComponent';
import ModalSimulatorOfficialQuestionView from './ModalSimulatorOfficialQuestionView';
import draggable from 'vuedraggable';

export default {
  name: 'ModalSimulatorOfficialSectionView',
  components: {
      'modal-simulator-question-view': ModalSimulatorOfficialQuestionView,
      draggable,
  },
  extends: ModalSimulatorOfficialSectionComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Sección"
      width="55%"
      class="simulator-official-section-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Sección</legend>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="12 "
              :md="12"
              :lg="12"
              :xl="14"
            >
              <el-form-item
                label="Nombre"
                prop="name"
              >
                <el-input
                  v-model="formData.name"
                  maxlength="120"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="7"
              :md="7"
              :lg="7"
              :xl="5"
            >
              <el-form-item
                label="Numero de Preguntas"
                prop="questionQuantity"
              >
                <el-input-number
                  v-model="formData.questionQuantity"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="5"
              :md="5"
              :lg="5"
              :xl="5"
            >
              <el-form-item
                label="Orden"
                prop="sort"
              >
                <el-input-number
                  v-model="formData.sort"
                  size="small"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <!--
                        <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4" align="center">
                            <el-form-item label="Especialidad" prop="isSpecialty">
                                <el-switch v-model="formData.isSpecialty" active-text="SI" inactive-text="NO" @change="onChangeIsSpecialty"></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10">
                            <el-form-item label="Carrera" prop="specialties">
                                <el-select v-model="formData.specialties" placeholder="Seleccionar" value-key="id" multiple clearable filterable :disabled="!formData.isSpecialty">
                                    <el-option v-for="item in careers" :key="item.id" :label="item.name" :value="item" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        -->
          </el-row>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Descripción"
                prop="description"
              >
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  :row="3"
                  maxlength="255"
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Questions Header -->
          <div class="simulator-section-header">
            <div class="title-icon">
              <h3 class="title">
                <i class="uil uil-question-circle" /> Preguntas de la Sección
              </h3>
            </div>
            <el-button
              type="primary"
              size="small"
              class="btn-primary"
              icon="el-icon-circle-plus"
              @click="onAddQuestion"
            >
              Agregar Pregunta
            </el-button>
          </div>

          <div
            v-loading="isQuestionsLoading"
            class="simulator-sections-wrapper"
          >
            <!-- Empty State -->
            <div
              v-if="!hasVisibleQuestions()"
              class="simulator-sections-empty"
            >
              <el-empty
                :image-size="70"
                description="No hay preguntas asignadas a esta sección todavía."
              >
                <el-button
                  type="primary"
                  size="small"
                  class="btn-primary"
                  icon="el-icon-circle-plus"
                  @click="onAddQuestion"
                >
                  Agregar Primera Pregunta
                </el-button>
              </el-empty>
            </div>

            <!-- Questions Table -->
            <div
              v-else
              class="simulator-sections-table"
            >
              <div class="sections-table-head">
                <div class="th-col col-sort">ORDEN</div>
                <div class="th-col col-code">CÓDIGO</div>
                <div class="th-col col-title">PREGUNTA</div>
                <div class="th-col col-category">CATEGORÍA</div>
                <div class="th-col col-type">TIPO</div>
                <div class="th-col col-actions">ACCIONES</div>
              </div>

              <draggable
                v-model="formData.simulatorSectionQuestions"
                item-key="sort"
                handle=".drag-handle"
                ghost-class="ghost-section-row"
                @change="onChangeDrag(formData.simulatorSectionQuestions)"
              >
                <template #item="{ element, index }">
                  <div
                    v-show="element.updateState !== formData.UPDATE_STATUS.REMOVED"
                    :key="element.sort || index"
                    class="sections-table-row"
                  >
                    <!-- Drag / Order -->
                    <div class="td-col col-sort">
                      <i
                        class="fa fa-grip-vertical drag-handle"
                        title="Arrastrar para ordenar"
                      />
                      <span class="order-badge">{{ element.sort }}</span>
                    </div>

                    <!-- Código -->
                    <div class="td-col col-code">
                      <span class="code-badge">
                        {{ element.simulatorQuestion ? element.simulatorQuestion.code : '-' }}
                      </span>
                    </div>

                    <!-- Pregunta / Nombre -->
                    <div class="td-col col-title">
                      <span
                        class="section-title-text"
                        v-html="element.simulatorQuestion ? element.simulatorQuestion.name : ''"
                      />
                    </div>

                    <!-- Categoría -->
                    <div class="td-col col-category">
                      <el-tag
                        size="small"
                        type="info"
                        effect="plain"
                      >
                        {{ element.simulatorQuestion && element.simulatorQuestion.simulatorQuestionCategory ? element.simulatorQuestion.simulatorQuestionCategory.name : '-' }}
                      </el-tag>
                    </div>

                    <!-- Tipo -->
                    <div class="td-col col-type">
                      <el-tag
                        v-if="element.simulatorQuestion && element.simulatorQuestion.type === 1"
                        size="small"
                        type="info"
                        effect="plain"
                      >
                        Público
                      </el-tag>
                      <el-tag
                        v-else-if="element.simulatorQuestion && element.simulatorQuestion.type === 2"
                        size="small"
                        type="success"
                        effect="plain"
                      >
                        Privado
                      </el-tag>
                      <el-tag
                        v-else-if="element.simulatorQuestion && element.simulatorQuestion.type === 3"
                        size="small"
                        type="warning"
                        effect="plain"
                      >
                        Ambos
                      </el-tag>
                      <span v-else>-</span>
                    </div>

                    <!-- Acciones -->
                    <div class="td-col col-actions">
                      <el-button
                        size="small"
                        class="btn-row-action btn-row-delete"
                        title="Eliminar pregunta"
                        @click="onRemoveQuestion(element)"
                      >
                        <i class="el-icon-delete" />
                      </el-button>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </fieldset>
      </el-form>
      <template #footer>
        <span 
          class="dialog-footer"
        >
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Aceptar</el-button>
        </span>
      </template>
    </el-dialog>
    <modal-simulator-question-view
      v-if="modalItemQuestion.isVisible"
      :form-data="itemQuestion"
      :conf="modalItemQuestion"
    />
  </div>
</template>